import { servicesPlugin, pushStateLocationPlugin } from '@uirouter/react';
import router from './index';

// Create a new instance of the Router
router.plugin(servicesPlugin);
router.plugin(pushStateLocationPlugin); // alternative = hashLocationPlugin

router.urlService.config.strictMode(false);

// Initial state when the router is first loaded
router.urlService.rules.initial({ state: 'login' });
// Fallback page if state can't be found
router.urlService.rules.otherwise({ state: '404' });


// Start the router
//router.start();

export default router;